/**
 * Route for `per-sub-network-user-entitlements`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PerSubNetworkUserEntitlementsPage } from "../features/per-sub-network-user-entitlements/PerSubNetworkUserEntitlementsPage";

export const perSubNetworkUserEntitlementsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/per-sub-network-user-entitlements",
	component: PerSubNetworkUserEntitlementsPage,
});

export default perSubNetworkUserEntitlementsRoute;
